export default __webpack_public_path__ + "static/media/1.d72fdc33.png";